import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=3be960bb&scoped=true&lang=pug"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.vue?vue&type=style&index=0&id=3be960bb&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be960bb",
  null
  
)

export default component.exports